module.exports = __webpack_public_path__ + "media/images/home/celebrity-amy-poehler-ea63cb52ddafc3a2ccb851aeb9e42e47.jpg";